import { useSelector } from 'react-redux'
import { State } from 'reducers'
import { FooterView } from './Footer.view'

export const Footer = () => {
  const version = useSelector((state: State) => state.version.number)
  return <FooterView version={version}/>
}
